import { Dispatch } from "redux";
import request from "../../../Requests/requests";
// import { loadDataTag } from "../../../store/tagsReducer";

export const FETCH_DATA_REQUEST_TAGS = 'FETCH_DATA_REQUEST_TAGS';
export const FETCH_DATA_RESPONSE_TAGS = 'FETCH_DATA_RESPONSE_TAGS';
export const FETCH_DATA_RESPONSE_TAGS_ERR = 'FETCH_DATA_RESPONSE_TAGS_ERR';

export const getTagsList = () => {
    return async (dispatch: Dispatch) => {
        dispatch({ type: 'FETCH_DATA_REQUEST_TAGS' })

        return await request.get('/Tag/Tags/', { params: {
            UserId: localStorage.getItem('userID')}})
            .then(response => response.data)
            .then(data => {
                dispatch({ type: 'FETCH_DATA_RESPONSE_TAGS', payload: data})
            })
            .catch(error => {
                dispatch({ type: 'FETCH_DATA_RESPONSE_TAGS_ERR', payload: error})
            })
    }
}